import { Filter } from "../../../types/filter";
import {
  Prefix,
  getNonEmptyUniqueSortedOptions,
  handlePrefix,
  isActiveFilter,
  stringOptionFactory,
} from "../utils";

export type StatusQueryParam = "status";
type SomethingWithStatus = {
  status?: string;
};

export const getStatusFilter = (
  data: SomethingWithStatus[],
  prefix?: Prefix
): Filter => ({
  label: "Status",
  queryParam: handlePrefix("status", prefix),
  options: getNonEmptyUniqueSortedOptions(
    data.map((d) => stringOptionFactory(d.status))
  ),
});

export const filterStatus = <T extends SomethingWithStatus>(
  data: T[],
  filters?: string[]
): T[] =>
  isActiveFilter(filters)
    ? data.filter((entry) => filters.includes(entry.status ?? ""))
    : data;
